document.addEventListener('DOMContentLoaded', () => {
    const zoomableImages = document.querySelectorAll('img.zoomable');
  
    // Preload high-res images in the background
    setTimeout(() => {
        zoomableImages.forEach(img => {
            if (img.dataset.zoomImage) {
                const preloadImg = new Image();
                preloadImg.src = img.dataset.zoomImage;
            }
        });
    }, 1000); // Wait 1 second after page load before preloading
  
    zoomableImages.forEach(img => {
      img.addEventListener('click', () => {
        createZoomedView(img);
      });
    });
  
    function createZoomedView(img) {
      const overlay = document.createElement('div');
      overlay.className = 'zoom-overlay';
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2147483647;
      `;
  
      const zoomedImg = document.createElement('img');
      zoomedImg.src = img.dataset.zoomImage || img.src;
      zoomedImg.style.cssText = `
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
      `;
  
      const closeButton = document.createElement('button');
      closeButton.innerHTML = '&times;';
      closeButton.style.cssText = `
        position: absolute;
        top: 20px;
        right: 20px;
        width: 30px;
        height: 30px;
        background-color: transparent;
        color: white;
        font-size: 24px;
        border: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      `;
  
      const closeZoom = () => {
        document.body.removeChild(overlay);
      };
  
      closeButton.addEventListener('click', closeZoom);
  
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          closeZoom();
        }
      });
  
      overlay.appendChild(zoomedImg);
      overlay.appendChild(closeButton);
      document.body.appendChild(overlay);
    }
  });